import CapacityHero from "./components/CapacityHero";
import CapacityTiers from "./components/CapacityTiers";
import CapacityProcess from "./components/CapacityProcess";
import CapacityPathwayNav from "./components/CapacityPathwayNav";
import CapacityOutcomes from "./components/CapacityOutcomes";

export default function Capacity() {
  return (
    <main className="min-h-screen">
      <CapacityHero />
      <CapacityTiers />
      <CapacityProcess />
      <CapacityPathwayNav />
      <CapacityOutcomes />
    </main>
  );
}